module.exports = __webpack_public_path__ + "media/src/images/petal_cutted-27404922edccb60d71c4ae040634ae96.png";